// extracted by mini-css-extract-plugin
export default {"professionSection":"styles_professionSection__PN-gV","professionText":"styles_professionText__FGXAk"};